var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolCobbAngle = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  transform: "translate(6.5 .68)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M8.5 10.182a2.5 2.5 0 0 1 2.5 2.5v1a2.5 2.5 0 0 1-2.5 2.5h-6a2.5 2.5 0 0 1-2.5-2.5v-1a2.5 2.5 0 0 1 2.5-2.5zm0 1.5h-6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 8.698,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 17.698,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M12.345 2.907a2.5 2.5 0 0 1 1.494 3.204l-.342.94a2.5 2.5 0 0 1-3.204 1.494L4.655 6.493A2.5 2.5 0 0 1 3.16 3.29l.342-.94A2.5 2.5 0 0 1 6.707.855zm-.513 1.41L6.194 2.265a1 1 0 0 0-1.282.597l-.342.94a1 1 0 0 0 .598 1.282l5.638 2.052a1 1 0 0 0 1.282-.598l.342-.94a1 1 0 0 0-.598-1.281M10.293 17.855a2.5 2.5 0 0 1 3.204 1.494l.342.94a2.5 2.5 0 0 1-1.494 3.204l-5.638 2.052a2.5 2.5 0 0 1-3.204-1.494l-.342-.94a2.5 2.5 0 0 1 1.494-3.204zm.513 1.41-5.638 2.052a1 1 0 0 0-.598 1.281l.342.94a1 1 0 0 0 1.282.598l5.638-2.052a1 1 0 0 0 .598-1.282l-.342-.94a1 1 0 0 0-1.282-.597"
})))));
export { SvgToolCobbAngle as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-cobb-angle.svg";